import { HelpPanel, Link } from '@amzn/awsui-components-react';
import { externalLinks } from '../../../../data/externalLinks';
import React from 'react';
import { useLocalizedText } from '../../../../hooks/localizedText';
import { LocalizedTrans } from '../../../../hooks/localization/localizedTrans';

export function CoordinatorNotificationHelpPanel() {
  const { t } = useLocalizedText(['events']);
  return (
    <HelpPanel
      header={<h2>{t('notificationPreferences.infoHeader')}</h2>}
      footer={
        <>
          <h2>{t('notificationPreferences.infoLearnMoreTitle')}</h2>
          <Link
            href={externalLinks.events.coordinatorNotificationUserGuide}
            external
            data-aci-analytics-name="eventCreation_coordNotificationGuideLinkClicked"
            data-aci-analytics-value="Coordinator Notifications User Guide"
          >
            {t('notificationPreferences.infoUserGuideLink')}
          </Link>
        </>
      }
    >
      <p>{t('notificationPreferences.infoGeneral')}</p>
      <h3>{t('notificationPreferences.realTimeInfoHeader')}</h3>
      <p>{t('notificationPreferences.infoRealTime.para1')}</p>
      <p>{t('notificationPreferences.infoRealTime.para2')}</p>
      <h3>{t('notificationPreferences.summaryInfoHeader')}</h3>
      <p>{t('notificationPreferences.infoSummary.intro')}</p>
      <ul>
        <li>
          <LocalizedTrans
            i18nKey="events:notificationPreferences.infoSummary.daily"
            components={{ b: <b /> }}
          />
        </li>
        <li>
          <LocalizedTrans
            i18nKey="events:notificationPreferences.infoSummary.weekly"
            components={{ b: <b /> }}
          />
        </li>
      </ul>
      <p>{t('notificationPreferences.infoSummary.closing')}</p>
    </HelpPanel>
  );
}
